
/* injects from baggage-loader */

'use strict';

export default class AccountController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
